import { combineReducers } from '@reduxjs/toolkit';
import product from './product/index';
import comments from './comments/index';
import technicalError from './technicalError/technicalError';
import orders from './orders/index';
import order from './order/index';
import auth from './auth/index';
import account from './account/index';
import payments from './payments';
import recipientEdit from './recipientEdit';
import deliveryEdit from './deliveryEdit';
import deliveryCalculation from './deliveryCalculation/index';
import managersFromYandex from './managersFromYandex/index';
import managersAccesses from './managersAccesses/index';
import managersList from './managersList/index';
import vendors from './vendors/index';
import vendorApplications from './vendor-applications/index';
import reviews from './reviews/index';
import questions from './questions/index';
import pvzMap from './pvzMap/index';
import notifications from './notifications/index';
import soundSettings from './soundSettings/index';
import nativeNotificationSettings from './nativeNotificationSettings/index';
import unviewedOrders from './unviewedOrders/index';

const rootReducer = combineReducers({
  product,
  comments,
  technicalError,
  orders,
  order,
  auth,
  account,
  payments,
  recipientEdit,
  deliveryEdit,
  deliveryCalculation,
  managersFromYandex,
  managersAccesses,
  managersList,
  vendors,
  vendorApplications,
  reviews,
  questions,
  pvzMap,
  notifications,
  soundSettings,
  nativeNotificationSettings,
  unviewedOrders
});

export default rootReducer;
